import MobileIconUi from 'client/components/core/Sidebar/components/Settings/styles/ui/MobileIconUi'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'

type SpacingNewProps = {
  spacing: number
  subMenuSpacing?: number
  mobileSubMenuSpacing?: number
  mobileSpacing?: number
  update: (value: number) => void
  updateSubMenu: (value: number) => void
  updateMobileSubMenu: (value: number) => void
  updateMobile: (value: number) => void
  hasSubMenu: boolean
}

export const MenuSpacing = ({
  spacing,
  mobileSpacing,
  update,
  updateMobile,
  subMenuSpacing,
  mobileSubMenuSpacing,
  updateMobileSubMenu,
  updateSubMenu,
  hasSubMenu,
}: SpacingNewProps) => {
  const { isMobile } = useDeviceModeContext()

  return (
    <div>
      <GroupTitle afterChildren={isMobile && <MobileIconUi />}>
        settings_styles.margin.label
      </GroupTitle>
      <RangeElement
        value={isMobile ? mobileSpacing : spacing}
        label={'entity_settings.menu.item.spacing'}
        onChange={isMobile ? updateMobile : update}
      />
      {hasSubMenu && (
        <RangeElement
          value={isMobile ? mobileSubMenuSpacing : subMenuSpacing}
          label={'entity_settings.menu.item.submenu_spacing'}
          onChange={isMobile ? updateMobileSubMenu : updateSubMenu}
        />
      )}
    </div>
  )
}
